import styled, { css } from "styled-components";
import { propStyling, PropsWithPropStyling } from "../../../shared/propStyling";
import { tombac } from "../../../shared/tombac";

export type ButtonContainerProps = PropsWithPropStyling<{
  $withAddon: boolean;
}>;

export const Container = styled.button<ButtonContainerProps>`
  all: initial;

  ${({
    theme: {
      components: {
        button: { current },
      },
    },
  }) => css<ButtonContainerProps>`
    align-items: center;
    background-color: ${tombac.parse(current!.backgroundColor)};
    border-radius: 9999rem;
    box-sizing: border-box;
    display: inline-flex;
    height: ${tombac.parse(current!.height)};
    isolation: isolate;
    justify-content: center;
    min-width: ${tombac.parse(current!.height)};
    overflow: hidden;
    padding: ${({ $withAddon }) =>
      tombac.parse(
        `0 ${$withAddon ? current!.withAddon!.padding : current!.padding}`
      )};
    position: relative;
    text-decoration: none;
    transition: 0.1s ease-out;
    transition-property: background-color, box-shadow;

    &:focus-visible {
      box-shadow: ${tombac.parse(`0 0 0 3u ${current!.focusRing}`)};
    }

    &:not(:disabled) {
      cursor: pointer;
    }

    &:not(:disabled):hover,
    &:not(:disabled):active {
      background-color: ${tombac.parse(current!.hover?.backgroundColor)};
    }

    &:disabled:not([data-busy]) {
      background-color: ${tombac.parse(current!.disabled?.backgroundColor)};
    }
  `}

  ${propStyling}
`;
